export enum ValueType {
  PERCENT = 'PERCENT',
  ABSOLUTE = 'ABSOLUTE',
}
